import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  DateField,
  ListContextProvider,
  useListContext,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
  useRefresh,
  Title,
} from 'react-admin';

import { Divider, Tabs, Tab, Card, makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DetailsIcon from '@material-ui/icons/Details';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import MinimizeIcon from '@material-ui/icons/Minimize';
import PrintIcon from '@material-ui/icons/Print';
import { useSnackbar } from 'notistack';

import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { imprimirPacoteMalote } from '../../services/impressora';
import { stylesMalote } from '../../utils';
import { PERMISSAO_TELA_MALOTES_LISTAR } from '../../utils/dadosTelas';
import DialogoLixeira from '../MaloteSangrias/DialogoLixeira';
import ValorTransferenciaField from '../Transacoes/Fields/ValorTransferenciaField';
import Actions from './ActionsList';
import DialogoCriarMaloteCompatibilidade from './DialogoCreate';
import DialogoCriarMalote from './DialogoCriarMalote';
import DialogoDesmembrarMalote from './DialogoDesmembrarMalote';
import DialogoEditarMalote from './DialogoEditarMalote';
import DialogoFecharMalote from './DialogoFecharMalote';
import DailogoShowMalote from './DialogoShowMalote';
//import ActionsField from './Fields/ActionsField';
import CodigoField from './Fields/CodigoField';
import ContaField from './Fields/ContaField';
import StatusField from './Fields/StatusField';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => stylesMalote);
const tabs = [
  { id: 'nao_conferido', name: 'Não Enviados' },
  { id: 'conferido', name: 'Enviados' },
];
//
const MyList = ({ ...props }) => {
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [confirmados, setConfirmados] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  const refDialogoFecharMalote = useRef(null);
  const refresh = useRefresh();
  const classes = useStylesDatagrid();
  const refDialogoShowMalote = useRef(null);
  const refDialogoEditarMalote = useRef(null);
  const refDialogoCriarMalote = useRef(null);
  const refDialogoCriarMaloteCompatibilidade = useRef(null);
  const refDialogoDesmembrarMalote = useRef(null);
  const refDialogoLixeira = useRef(null);

  function fecharMalote(record) {
    if (refDialogoFecharMalote.current)
      refDialogoFecharMalote.current.handleOpen(record.id);
  }

  const edit = (data) => {
    if (refDialogoEditarMalote.current) {
      refDialogoEditarMalote.current.handleOpen(data.id);
    }
  };

  const show = (data) => {
    if (refDialogoShowMalote.current) {
      refDialogoShowMalote.current.handleOpen(data.id);
    }
  };

  const create = (data) => {
    if (refDialogoCriarMalote.current) {
      refDialogoCriarMalote.current.handleOpen();
    }
  };

  const createCompatibilidade = (data) => {
    if (refDialogoCriarMaloteCompatibilidade.current) {
      refDialogoCriarMaloteCompatibilidade.current.handleOpen();
    }
  };

  const desmembrarMalote = (data) => {
    if (refDialogoDesmembrarMalote.current) {
      refDialogoDesmembrarMalote.current.handleOpen(data.id);
    }
  };

  useEffect(() => {
    if (ids && ids !== filterValues.visible) {
      switch (filterValues.visible) {
        case false:
          setConfirmados(ids);
          break;
        case true:
          setCancelados(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.visible]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          { ...filterValues, visible: value !== 'conferido' },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  function handleClose() {
    refresh();
  }

  function handleLixeira(data) {
    if (refDialogoLixeira.current) {
      refDialogoLixeira.current.handleOpen(data.id);
    }
  }

  const { enqueueSnackbar } = useSnackbar();

  async function imprimir(id) {
    if (id > 0) {
      const codigo = await imprimirPacoteMalote(id);
      if (codigo < 0) {
        enqueueSnackbar('Erro ao imprimir a nota!', {
          variant: 'error',
        });
      }
    }
  }

  return (
    <>
      <Title title="Malotes" />
      <ListToolbar
        filters={props.filters}
        actions={
          <Actions
            {...props}
            handleCriar={create}
            handleCriarCompatibilizacao={createCompatibilidade}
          />
        }
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={!filterValues.visible ? tabs[1].id : tabs[0].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.visible === true && (
            <ListContextProvider value={{ ...listContext, ids: cancelados }}>
              <Datagrid>
                <StatusField
                  source="codigo"
                  label=""
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <CodigoField
                  source="codigo"
                  label="Código"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <DateField
                  source="data_pagamento"
                  label="Criação"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  options={{ hour: 'numeric', minute: 'numeric' }}
                  sortable={false}
                />
                <Textofield
                  label="Criador"
                  source="criador.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Quem Atualizou"
                  source="atualizador.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <ContaField
                  label="Conta"
                  source="conta_id"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <ValorTransferenciaField
                  source="valor"
                  textAlign="right"
                  label="Valor"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.valorCell}
                  sortable={false}
                />
                <ActionsField
                  source="lalala"
                  /*           handleEdit={edit}
                  handleEfetivar={fecharMalote}
                  handleShow={show}
                  handleDesmembrar={desmembrarMalote} */
                  textAlign="right"
                  label="Ações"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.actionsCell}
                  sortable={false}
                  //handleLixeira={handleLixeira}
                  actions={[
                    {
                      title: 'Desmembrar Malote',
                      icon: ({ record }) => <MinimizeIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => desmembrarMalote(record),
                    },
                    {
                      title: 'Efetivar',
                      icon: ({ record }) =>
                        record.status ? (
                          <CheckCircleOutlineIcon />
                        ) : (
                          <CancelIcon />
                        ),
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => fecharMalote(record),
                      vazio: <div />,
                    },
                    {
                      title: 'Detalhes',
                      icon: <DetailsIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => show(record),
                    },
                    {
                      labtitleel: 'Editar',
                      icon: <EditOutlinedIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => edit(record),
                      vazio: <div />,
                    },
                    {
                      title: 'Imprimir',
                      icon: <PrintIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => imprimir(record?.id || -1),
                    },
                    {
                      title: 'Mandar para a lixeira',
                      icon: <DeleteForeverIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => handleLixeira(record),
                      vazio: <div />,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.visible === false && (
            <ListContextProvider value={{ ...listContext, ids: confirmados }}>
              <Datagrid>
                <StatusField
                  source="codigo"
                  label=""
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <CodigoField
                  source="codigo"
                  label="Código"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <DateField
                  source="data_pagamento"
                  label="Criação"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  options={{ hour: 'numeric', minute: 'numeric' }}
                  sortable={false}
                />
                <Textofield
                  label="Criador"
                  source="criador.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Quem Fechou"
                  source="atualizador.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <ContaField
                  label="Conta"
                  source="conta_id"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <ValorTransferenciaField
                  source="valor"
                  textAlign="right"
                  label="Valor"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.valorCell}
                  sortable={false}
                />
                <ActionsField
                  source="lalala"
                  /*      handleEdit={edit}
                  handleEfetivar={fecharMalote}
                  handleShow={show}
                  handleDesmembrar={desmembrarMalote} */
                  textAlign="right"
                  label="Ações"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.actionsCell}
                  sortable={false}
                  actions={[
                    {
                      title: 'Desmembrar Malote',
                      icon: ({ record }) => <MinimizeIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => desmembrarMalote(record),
                    },
                    {
                      title: 'Efetivar',
                      icon: ({ record }) =>
                        record.status ? (
                          <CheckCircleOutlineIcon />
                        ) : (
                          <CancelIcon />
                        ),
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => fecharMalote(record),
                      vazio: <div />,
                    },
                    {
                      title: 'Detalhes',
                      icon: <DetailsIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => show(record),
                    },
                    {
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => edit(record),
                      vazio: <div />,
                    },
                    {
                      title: 'Imprimir',
                      icon: <PrintIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => imprimir(record?.id || -1),
                    },
                    {
                      title: 'Mandar para a lixeira',
                      icon: <DeleteForeverIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => handleLixeira(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoFecharMalote
        ref={refDialogoFecharMalote}
        handleClose={handleClose}
      />
      <DailogoShowMalote ref={refDialogoShowMalote} />
      <DialogoCriarMalote
        ref={refDialogoCriarMalote}
        handleClose={handleClose}
      />
      <DialogoEditarMalote
        ref={refDialogoEditarMalote}
        handleClose={handleClose}
      />
      <DialogoCriarMaloteCompatibilidade
        ref={refDialogoCriarMaloteCompatibilidade}
        handleClose={handleClose}
      />
      <DialogoDesmembrarMalote
        ref={refDialogoDesmembrarMalote}
        handleClose={handleClose}
      />
      <DialogoLixeira ref={refDialogoLixeira} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_MALOTES_LISTAR}>
    <ContainerMyList
      {...props}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Malotes"
      filterDefaultValues={{
        visible: true,
      }}
    />
  </ProtegerPagina>
);

export default List2;
